module.exports = __webpack_public_path__ + "img/qgsg-1_32-100.prt.389eab2a.jpg";